import { useEffect, useState } from 'react';

import { omit } from 'lodash';
import { useSnapshot } from 'valtio';

import {
  getBookingsExpandedQueryWhereClauseFromFilters,
  getEnergyUsageInputFromFilters,
  store,
} from '@/components/pages/EmissionsDashboard/store';

import { useGetBookingsExpandedQuery } from '@/graphql/GetBookingsExpanded.generated';

import { usePostEnergyUsage, usePostEnergyUsageByHour } from '@/hooks';

function useRawDataDownload() {
  const snap = useSnapshot(store);

  const [data, setData] = useState<unknown | null>(null);

  const params = getEnergyUsageInputFromFilters(snap as typeof store);
  const [energyUsageByMonthResult, _refreshByMonth] =
    usePostEnergyUsage(params);

  const [energyUsageByHourResult, _refreshByHour] =
    usePostEnergyUsageByHour(params);

  const [bookingsExpandedResult, _reexecuteGetBookingsExpandedQuery] =
    useGetBookingsExpandedQuery({
      variables: {
        where: getBookingsExpandedQueryWhereClauseFromFilters(
          snap as typeof store,
        ),
      },
    });

  useEffect(() => {
    if (
      bookingsExpandedResult.data &&
      energyUsageByMonthResult.data &&
      energyUsageByHourResult.data
    ) {
      setData({
        bookings:
          bookingsExpandedResult.data.container_insights_bookings_expanded.map(
            (booking) => omit(booking, ['internal_booking_id', '__typename']),
          ),
        usageByMonth: energyUsageByMonthResult.data,
        dailyAverage: energyUsageByHourResult.data.map((d) => ({
          ...d,
          hour: (d.hour + '').padStart(2, '0'),
        })),
      });
    }
  }, [
    bookingsExpandedResult.data,
    energyUsageByMonthResult.data,
    energyUsageByHourResult.data,
  ]);

  return data;
}

export { useRawDataDownload };
